import { CopyableTableCell } from "@/components/typography/dfp-typography";
import { Skeleton, Tag } from "antd";
import { EditableCell } from "../../../TableComponents/EditableCell";
import { handleSave } from "../../../TableComponents/handleEditSave";

export const getColumns = (
	getUsers: () => Promise<void>,
	organizationId: number,
	role_id: number,
) => [
	{
		title: "Name",
		dataIndex: "name",
		key: "name",
		sorter: true,
		sortDirections: ["descend", "ascend", "descend"],
		render: (text: string, record: any) => {
			if (record.isLoading) return <Skeleton.Input active size="small" />;
			return role_id === 4 ? (
				<EditableCell
					value={text}
					record={record}
					dataIndex="name"
					handleSave={(record: any) => handleSave(record, getUsers, organizationId)}
				/>
			) : (
				<CopyableTableCell text={text} />
			);
		},
		width: 200,
	},
	{
		title: "Email",
		dataIndex: "email",
		key: "email",
		sorter: true,
		sortDirections: ["descend", "ascend", "descend"],
		render: (text: string, record: any) => (
			<CopyableTableCell text={text} isLoading={record.isLoading} />
		),
		width: 240,
	},
	{
		title: "Phone",
		dataIndex: "phone_number",
		key: "phone_number",
		render: (text: string, record: any) => {
			if (record.isLoading) return <Skeleton.Input active size="small" />;
			return text ? <CopyableTableCell text={text} /> : <span style={{ color: "#adb5bd" }}>—</span>;
		},
		width: 140,
	},
	{
		title: "Role",
		dataIndex: ["role", "name"],
		key: "role",
		render: (text: string, record: any) => (
			<CopyableTableCell text={text} isLoading={record.isLoading} />
		),
		width: 120,
	},
	{
		title: "Status",
		dataIndex: "is_disabled",
		key: "status",
		render: (isDisabled: boolean, record: any) => {
			if (record.isLoading) return <Skeleton.Input active size="small" />;
			const active = !isDisabled && !record.isAccountDisabled;
			return (
				<Tag
					color={active ? "#198754" : "#dc3545"}
					style={{
						minWidth: 72,
						textAlign: "center",
						fontWeight: 500,
						borderRadius: 4,
					}}
				>
					{active ? "Active" : "Disabled"}
				</Tag>
			);
		},
		width: 100,
	},
	{
		title: "Last Login",
		dataIndex: "last_login_at",
		key: "last_login",
		sorter: true,
		sortDirections: ["descend", "ascend", "descend"],
		render: (text: string, record: any) => {
			if (record.isLoading) return <Skeleton.Input active size="small" />;
			if (!text) return <span style={{ color: "#adb5bd" }}>Never</span>;
			try {
				const date = new Date(text);
				return (
					<span style={{ fontSize: "0.85rem", color: "#495057" }}>
						{date.toLocaleDateString("en-US", {
							month: "short",
							day: "numeric",
							year: "numeric",
						})}
					</span>
				);
			} catch {
				return <span style={{ color: "#adb5bd" }}>—</span>;
			}
		},
		width: 140,
	},
];
